import { SET_AMENITIES, UPDATE_AMENITIES, AMENITY_FAILED, SET_PROPERTY_FIELDS } from '../../types';
import { setAlert } from '../alert';

//  setAmenities function will be called from properties "getPropertyAssets"
//  the purpose is format and create a new amenities object that will works with the UI
//  this function DOES NOT denpends on updateAmenities to acuatlly update the amenities object

import Debugger from '@debugger';
const logger = new Debugger('Properties:Action:Amenities');

export const setAmenities = () => async(dispatch, getState) => {
    try {
        const { properties: { propertyData: { amenities, property_amenities } } } = getState();

        /**
		 * Merge amenities and property_amentities for data mapping
		 * to Amenities tab and use this for back-end processing
		 */
        const newAmenities = amenities.map((amenity) => {
            const checkedAmenity = property_amenities.find((item) => item.amenity_id === amenity.id);
            if (checkedAmenity) {
                return {
                    ...amenity,
                    ...checkedAmenity
                };
            }
            return {
                ...amenity,
                amenity_id: null,
                subtype: null
            };

        });

        dispatch({
            type: SET_AMENITIES,
            payload: newAmenities
        });
    }
    catch (error) {
        dispatch({ type: AMENITY_FAILED });
        dispatch(setAlert('Set Amenity Failed ' + error.message, 'error', 2000));
    }
};

//  This updateAmenities function handles update amenities object
//  It will be called from properties action "updatePropertyFields"

export const updateAmenities = (event) => async(dispatch, getState) => {
    try {
    //	Check for amenity_notes and update property regularly
        console.log('updateAmenities');
        logger.log('updateAmenities', event);
        if (event.target.name === 'amenity_notes') {
            logger.log('updateAmenities if', event);
            const { properties: { propertyFields } } = getState();
            const newPropertyFields = {
                ...propertyFields,
                [event.target.name]: event.target.value
            };
            dispatch({
                type: SET_PROPERTY_FIELDS,
                payload: newPropertyFields
            });
        }
        else {
            logger.log('updateAmenities else ', event);
            //	@TODO: Write explaination for this logic
            const { propertyAmenities: { amenities } } = getState();

            let newAmenities = [{}];

            if (event.target.checked === true) {
                newAmenities = amenities.map((item) => {
                    if (String(item.id) === event.target.value) {
                        return {
                            ...item,
                            amenity_id: parseInt(event.target.value)
                        };
                    }
                    return item;

                });
            }
            else if (event.target.checked === false) {
                newAmenities = amenities.map((item) => {
                    if (String(item.id) === event.target.value) {
                        return {
                            ...item,
                            amenity_id: null,
                            subtype: null
                        };
                    }
                    return item;

                });
            }
            else if (event.target.type === 'select-one') {
                newAmenities = amenities.map((item) => {
                    if (String(item.id) === event.target.dataset.parent) {
                        return {
                            ...item,
                            subtype: event.target.value
                        };
                    }
                    return item;

                });
            }

            dispatch({
                type: UPDATE_AMENITIES,
                payload: newAmenities
            });
        }
    }
    catch (error) {
        dispatch({ type: AMENITY_FAILED });
        dispatch(setAlert('Set Amenity Failed ' + error.message, 'error', 5000));
    }
};
